var _circle, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgContact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 68,
    viewBox: "0 0 68 68"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 34,
    fill: "#E65A3D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 37.5c-.617-.084-1.409-.32-2-.5l-6.5 2.5L23 35c-1.984-1.587-3-3.81-3-6.256C20 23.915 24.798 20 30.717 20c5.92 0 10.718 3.915 10.718 8.744"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.348 39.544c0 5.407 6.479 9.479 12.152 6.957l5 2-2.022-3.914C48.112 43.279 49 41.556 49 39.543c0-3.976-3.951-7.564-8.826-7.564-4.874 0-8.826 3.588-8.826 7.565h0z"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2OCIgaGVpZ2h0PSI2OCIgdmlld0JveD0iMCAwIDY4IDY4Ij4KICAgIDxjaXJjbGUgY3g9IjM0IiBjeT0iMzQiIHI9IjM0IiBmaWxsPSIjRTY1QTNEIi8+CiAgICA8ZyBzdHJva2U9IiNGRkYiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjAgMjApIj4KICAgICAgPHBhdGggZD0iTTksMTcuNSBDOC4zODMsMTcuNDE2IDcuNTkxLDE3LjE4IDcsMTcgTDAuNSwxOS41IEwzLDE1IEMxLjAxNiwxMy40MTMgMi4wMDcyODMyM2UtMTMsMTEuMTkgMi4wMDcyODMyM2UtMTMsOC43NDQgQzIuMDA3MjgzMjNlLTEzLDMuOTE1IDQuNzk4LDAgMTAuNzE3LDAgQzE2LjYzNywwIDIxLjQzNSwzLjkxNSAyMS40MzUsOC43NDQiLz4KICAgICAgPHBhdGggZD0iTTExLjM0NzcsMTkuNTQzNSBDMTEuMzQ3NywyNC45NTA1IDE3LjgyNjcsMjkuMDIyNSAyMy40OTk3LDI2LjUwMDUgTDI4LjQ5OTcsMjguNTAwNSBMMjYuNDc3NywyNC41ODY1IEMyOC4xMTE3LDIzLjI3OTUgMjguOTk5NywyMS41NTc1IDI4Ljk5OTcsMTkuNTQzNSBDMjguOTk5NywxNS41NjY1IDI1LjA0ODcsMTEuOTc4NSAyMC4xNzM3LDExLjk3ODUgQzE1LjI5OTcsMTEuOTc4NSAxMS4zNDc3LDE1LjU2NjUgMTEuMzQ3NywxOS41NDM1IEwxMS4zNDc3LDE5LjU0MzUgWiIvPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgContact as ReactComponent };